module.exports = __webpack_public_path__ + "img/mini-logo.e99f0bb7.png";